const colors = {
  green: '#00a900',
  yellow: '#ecec00',
  red: '#ff0000',
  gray: '#c0c0c0'
}

export default (value, forceGray) => {
  if (forceGray) {
    return colors.gray
  }
  if (value >= 70) {
    return colors.green
  } else if (value < 40) {
    return colors.red
  }
  return colors.yellow
}
